import React, { Component, createRef, useContext } from 'react';
import { string, bool, func, arrayOf, object, number, array } from 'prop-types';
import { noop } from 'lodash';
import ReactTooltip from 'react-tooltip';
import c from 'classnames';
import { Button, Modal } from '@stormwater-software/lib-ui';
import UploadInput from '../../FormInput/Upload';
import FileRow from './FileRow';
import uploadApi from '../../../utils/api/upload';
import RolesContext from '../../../contexts/RolesContext';
import Tooltip from '@mui/material/Tooltip';
import ReactToolTip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQuestionCircle,
  faArrowsAlt,
  faFolderPlus,
  faFolder,
  faTrashAlt,
  faEdit,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import AppContext from '../../../contexts/AppContext';
import TenantStore from '../../../contexts/TenantContext';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import projectApi from '../../../utils/api/project';
import { ProjectContext } from '../../../contexts/ProjectContext';
import { InspectionContext } from '../../../contexts/InspectionContext';
import inspectionApi from '../../../utils/api/inspection';
import { useHistory } from 'react-router-dom';
const SHOW_LESS_LIMIT = 3;

/**
 * List of file cards, visually grouped beneath a group name heading
 */
export class FileCardListUI extends Component {
  static propTypes = {
    groupName: string.isRequired,
    actualGroupName: string,
    documents: arrayOf(object).isRequired,
    allowedTypes: arrayOf(string), // array of mime_types

    // feature flags
    canEdit: bool,
    canDelete: bool,
    canReplace: bool,
    canRename: bool,
    canRestore: bool,
    canArchive: bool,
    hideTitle: bool,
    canUpload: bool,
    canDownload: bool,
    /**
     * Suppress the drag-and-drop upload control that `hideTitle` normally shows
     * above the table. Use it when the parent already renders its own upload
     * button for this list, so the two do not sit on top of each other.
     */
    hideRowUploadControl: bool,

    // callbacks for functionality handled in this component and its children
    onUpload: func,

    // functionality handled by the implementing/parent component
    handleDelete: func,
    handleEdit: func,
    handleRename: func,
    handleReplace: func,
    handleDownload: func,
    handleTrackPermit: func,
    label: string,
    permCheck: func.isRequired,
    showMoreThreshold: number,
    minimumImageDimensions: object,
    maxFileSize: number,
    isProjectDocumentsPage: bool,
    doTypes: array,
    setShouldReloadDocumentsPage: func,
    isAdmin: bool,
    canTenantEdit: bool,
    location: string,
    projectContext: object,
    isInspectionAttachment: bool,
    inspectionContext: object,
    isPublic: bool,
  };

  static defaultProps = {
    onUpload: noop,
    handleDelete: noop,
    canUpload: true,
    canDownload: true,
    canRename: true,
    showMoreThreshold: SHOW_LESS_LIMIT,
    maxFileSize: 75000000,
    minimumImageDimensions: {
      width: 50,
      height: 50,
    },
    showAddSubFolderIcon: false,
    canManageSubfolder: false,
  };

  constructor(props) {
    super(props);

    this.tableRef = createRef();
  }

  state = {
    isShowingMore: false,
    showMoveDocModal: false,
    showWarningForPermitDoc: false,
    sourceMainFolderId: null,
    destinationMainFolderId: null,
    destinationSubFolderId: null,
    selectedDocument: [],
    modalErrorMsg: '',
    isLoadingForModal: false,
    showReorderModal: false,
    tempReorderDocs:
      Array.isArray(this.props.documents) &&
      this.props.documents.filter((ele) => {
        if (this.props.selectedSubDocType) {
          if (this.props.selectedSubDocType.is_regulation_folder) {
            // Inside a regulation subfolder: include master docs AND project uploads
            return (
              ele.hasOwnProperty('ProjectRegulationUploadModel') ||
              ele.scope === 'master'
            );
          }
          return (
            ele.hasOwnProperty('ProjectUploadModel') &&
            ele.ProjectUploadModel.project_sub_doc_type_id !== null
          );
        }

        if (this.props.isRegulationsSection) {
          // Top-level project regulations: master docs, master/project folders, project docs.
          return (
            ele.hasOwnProperty('sub_doc_type') ||
            ele.hasOwnProperty('ProjectRegulationUploadModel') ||
            ele.scope === 'master'
          );
        }

        return (
          ele.hasOwnProperty('sub_doc_type') ||
          (ele.hasOwnProperty('ProjectUploadModel') &&
            ele.ProjectUploadModel.project_sub_doc_type_id === null)
        );
      }),
    showAddNewSubDocTypeModal: false,
    newSubDocTypeName: '',
    destinationAsSubFolderCheck: false,
    selectedMainDestinationFolder: { documents: [], project_doc_type_id: null },
    selectedSubDestinationFolder: {},
    showRenameSubDocTypeModal: false,
    showDeleteSubDocTypeModal: false,
    updatedSubDocTypeName: null,
  };

  toggleShowMore() {
    this.setState({ isShowingMore: !this.state.isShowingMore });
  }

  componentDidUpdate(prevProps) {
    ReactTooltip.rebuild();

    if (prevProps.documents !== this.props.documents) {
      this.setState({
        tempReorderDocs: this.props.documents.filter((ele) => {
          if (this.props.selectedSubDocType) {
            if (this.props.selectedSubDocType.is_regulation_folder) {
              return (
                ele.hasOwnProperty('ProjectRegulationUploadModel') ||
                ele.scope === 'master'
              );
            }
            return (
              ele.hasOwnProperty('ProjectUploadModel') &&
              ele.ProjectUploadModel.project_sub_doc_type_id !== null
            );
          }

          if (this.props.isRegulationsSection) {
            return (
              ele.hasOwnProperty('sub_doc_type') ||
              ele.hasOwnProperty('ProjectRegulationUploadModel') ||
              ele.scope === 'master'
            );
          }

          return (
            ele.hasOwnProperty('sub_doc_type') ||
            (ele.hasOwnProperty('ProjectUploadModel') &&
              ele.ProjectUploadModel.project_sub_doc_type_id === null) ||
            ele.hasOwnProperty('upload')
          );
        }),
      });
    }
  }

  render() {
    const {
      groupName,
      actualGroupName,
      documents,
      onUpload,
      handleDelete,
      handleEdit,
      handleRename,
      handleReplace,
      handleDownload,
      handleTrackPermit,
      permCheck,
      label,
      canEdit,
      canDelete,
      canReplace,
      canRename,
      canUpload,
      canDownload,
      hideTitle,
      allowedTypes,
      minimumImageDimensions,
      maxFileSize,
      onMove,
      onDrop,
      canDrag,
      document_date,
      isAdmin,
      isProjectDocumentsPage,
      setShouldReloadDocumentsPage,
      canTenantEdit,
      location,
      projectContext,
      documentType,
      selectedSubDocType,
      setSelectedSubDocType,
      reloadSelectedSubDocTypeData,
      isInspectionAttachment,
      inspectionContext,
    } = this.props;

    var { showMoreThreshold } = this.props;

    if (!showMoreThreshold) {
      showMoreThreshold = SHOW_LESS_LIMIT;
    }

    const docTypesWithCheckboxExcluded = ['Regulations'];
    const docTypesExcludedFromDestinationOptions = [
      'Regulations',
      'Fixed Details Project',
    ];

    const isPublic = window.location.pathname.startsWith('/public');

    const userCanMove = permCheck('update', 'Project Documents Move');

    const reorder = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);

      result.splice(endIndex, 0, removed);

      return result;
    };

    const handleOnDragEnd = (result) => {
      if (!result.destination) return;
      if (result.destination.index === result.source.index) return;

      const reordered = reorder(
        this.state.tempReorderDocs,
        result.source.index,
        result.destination.index,
      );

      this.setState({ tempReorderDocs: reordered });
    };

    const handleSubmitReorderProjectDocs = async () => {
      if (!isInspectionAttachment) {
        const isRegFolderSort = selectedSubDocType && selectedSubDocType.is_regulation_folder;
        const isProjectRegTopLevel =
          !selectedSubDocType &&
          this.props.isRegulationsSection &&
          this.props.projectId &&
          this.props.regulationDocumentGroupId;

        if (isProjectRegTopLevel) {
          const items = this.state.tempReorderDocs.map((doc) => {
            if (doc.is_regulation_folder) {
              return {
                type: doc.is_project_folder ? 'project_folder' : 'master_folder',
                id: doc.id,
              };
            }
            if (doc.scope === 'master') {
              return { type: 'master_doc', id: doc.id };
            }
            return {
              type: 'project_doc',
              id: doc.ProjectRegulationUploadModel?.id || doc.id,
            };
          });
          await uploadApi.projectRegulation.reorderTopLevel(
            this.props.projectId,
            this.props.regulationDocumentGroupId,
            items,
          );
          this.props.reloadDocs && (await this.props.reloadDocs());
        } else if (isRegFolderSort) {
          // Reorder inside a regulation subfolder. Use the snapshot endpoint so
          // master docs without an existing override row get one.
          const items = this.state.tempReorderDocs.map((doc) => {
            if (doc.scope === 'master') {
              return { type: 'master_doc', id: doc.id };
            }
            return {
              type: 'project_doc',
              id: doc.ProjectRegulationUploadModel?.id || doc.id,
            };
          });
          const docGroupId =
            selectedSubDocType.document_group_id ||
            this.props.regulationDocumentGroupId;
          await uploadApi.projectRegulation.reorderTopLevel(
            this.props.projectId,
            docGroupId,
            items,
          );
          selectedSubDocType && (await reloadSelectedSubDocTypeData());
          this.props.reloadDocs && (await this.props.reloadDocs());
        } else {
          let projectId =
            documents.length &&
            documents[0].ProjectUploadModel &&
            documents[0].ProjectUploadModel.project_id;
          await projectApi.sortDocs(
            this.state.tempReorderDocs,
            selectedSubDocType,
          );
          selectedSubDocType && (await reloadSelectedSubDocTypeData());
          projectId && (await setShouldReloadDocumentsPage((prevState) => !prevState));
        }
      } else if (isInspectionAttachment) {
        let inspectionId = documents.length && documents[0].inspection_id;
        await inspectionApi.sortInspUploads(
          inspectionId,
          this.state.tempReorderDocs,
        );
        inspectionId && inspectionContext.loadDocs(inspectionId);
      }

      this.setState({ showReorderModal: false });
    };

    const onMainDestinationFolderSelectHandler = (event) => {
      let selectedObject = JSON.parse(event.target.value);

      this.setState({
        sourceMainFolderId:
          this.state.selectedDocument[0].ProjectUploadModel.project_doc_type_id,
      });
      this.setState({ destinationMainFolderId: Number(selectedObject.id) });
      this.setState({ selectedMainDestinationFolder: selectedObject });
    };

    const onSubDestinationFolderSelectHandler = (event) => {
      let selectedObject = JSON.parse(event.target.value);

      this.setState({ destinationSubFolderId: Number(selectedObject.id) });
      this.setState({ selectedSubDestinationFolder: selectedObject });
    };

    const handleMoveDocModalCheck = () => {
      if (this.state.selectedDocument.length) {
        if (
          this.state.selectedDocument.filter(
            (ele) =>
              ele.ProjectUploadModel.permits.length > 0 &&
              ele.ProjectUploadModel.permits[0].status,
          ).length
        ) {
          this.setState({ showWarningForPermitDoc: true });
        } else {
          this.setState({ showMoveDocModal: true });
        }
      }
    };

    return (
      <section className='document-group'>
        {hideTitle ? null : (
          <div className='document-group__header'>
            <h3 className='document-group__title'>
              {`${groupName} `}
              {groupName === 'Fixed Details' && (
                <span
                  className='help-icon'
                  data-tip={
                    'Upload documents that do not need to be associated with a legend item and will always be available within a project.'
                  }
                  data-delay-show='125'
                  onMouseOver={() => ReactToolTip.show()}
                >
                  <FontAwesomeIcon icon={faQuestionCircle} />
                </span>
              )}
              {groupName === 'Permits' && (
                <span
                  className='help-icon'
                  data-tip={
                    'Red indicates the permit is expired. Orange indicates the permit will expire soon.'
                  }
                  data-delay-show='125'
                  onMouseOver={() => ReactToolTip.show()}
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                </span>
              )}
            </h3>

            <div className='document-group__header-right'>
              {this.state.selectedDocument.length ? (
                <FontAwesomeIcon
                  icon={faArrowsAlt}
                  color='rgb(56,89,128)'
                  onClick={handleMoveDocModalCheck}
                />
              ) : (
                <></>
              )}
              {canDrag &&
              (groupName !== 'Regulations' || this.props.isRegulationsSection) &&
              this.state.tempReorderDocs.length ? (
                <button
                  onClick={() => {
                    this.setState({ showReorderModal: true });
                  }}
                >
                  Organize
                </button>
              ) : (
                <></>
              )}
              {selectedSubDocType &&
              this.props.canManageSubfolder &&
              !(selectedSubDocType.is_regulation_folder && !selectedSubDocType.is_project_folder) ? (
                <div
                  className='document-group__add-sub-folder'
                  onClick={() => {
                    this.setState({ showDeleteSubDocTypeModal: true });
                  }}
                >
                  <FontAwesomeIcon icon={faTrashAlt} color='red' />
                </div>
              ) : (
                <></>
              )}
              {selectedSubDocType && this.props.canManageSubfolder ? (
                <div
                  className='document-group__add-sub-folder'
                  onClick={() => {
                    this.setState({ showRenameSubDocTypeModal: true });
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </div>
              ) : (
                <></>
              )}
              {!selectedSubDocType &&
              this.props.showAddSubFolderIcon &&
              this.props.canManageSubfolder ? (
                <div
                  className='document-group__add-sub-folder'
                  onClick={() => {
                    this.setState({ showAddNewSubDocTypeModal: true });
                  }}
                >
                  <FontAwesomeIcon icon={faFolderPlus} />
                </div>
              ) : (
                <></>
              )}
              {canUpload &&
                onUpload &&
                permCheck('update', label) &&
                permCheck('create', 'Uploads') && (
                  <div className='document-group__item-upload'>
                    <UploadInput
                      onUpload={(newFile) =>
                        onUpload ? onUpload(newFile) : null
                      }
                      imageDimensions={minimumImageDimensions}
                      allowedTypes={allowedTypes}
                      maxFileSize={maxFileSize}
                    />
                  </div>
              )}
            </div>
          </div>
        )}
        {/* empty state */}
        {!documents.length ? (
          <div className='document-group__empty-state'>
            <p className='document-group__title--empty-state'>
              No documents have been uploaded
            </p>
          </div>
        ) : null}
        {/* show the upload button here, when title is hidden */}
        {hideTitle &&
        !this.props.hideRowUploadControl &&
        permCheck('create', 'Uploads') &&
        permCheck('update', label) ? (
          <UploadInput
            onUpload={(newFile) => (onUpload ? onUpload(newFile) : null)}
            allowedTypes={allowedTypes}
            maxFileSize={maxFileSize}
            imageDimensions={minimumImageDimensions}
            className={c({
              'upload-control--cta': !documents.length,
              'upload-control--row': documents.length > 0,
            })}
            showHelpText
          />
        ) : null}
        {/* non-empty */}
        {documents.length ? (
          <table className='document-group__items' ref={this.tableRef}>
            <thead>
              <tr className='document-group__list-header'>
                {isProjectDocumentsPage &&
                userCanMove &&
                !docTypesWithCheckboxExcluded.includes(actualGroupName || groupName) ? (
                  <td></td>
                ) : (
                  <></>
                )}
                <th className='document-group__list-th'>Name</th>
                <th className='document-group__list-th'>
                  {actualGroupName === 'Permits' || groupName === 'Permits'
                    ? 'Status'
                    : 'Type'}
                </th>
                {document_date || isAdmin ? (
                  <>
                    <th className='document-group__list-th document-group__list-th--hide-on-mobile'>
                      Created
                    </th>

                    {(actualGroupName === 'Permits' ||
                      groupName === 'Permits') && (
                      <>
                        <th className='document-group__list-th document-group__list-th--hide-on-mobile'>
                          Issued
                        </th>
                        <th className='document-group__list-th document-group__list-th--hide-on-mobile'>
                          Expires
                        </th>
                      </>
                    )}

                    {actualGroupName !== 'Permits' &&
                      groupName !== 'Permits' && (
                        <th className='document-group__list-th document-group__list-th--hide-on-mobile'>
                          Updated
                        </th>
                      )}
                  </>
                ) : null}
                <th className='document-group__list-th'>
                  {/* Leave empty for CSS grid so table actions have room */}
                </th>
              </tr>
            </thead>

            <tbody>
              {(selectedSubDocType ||
              this.props.isRegulationsSection ||
              !(
                documents[0].hasOwnProperty('sub_doc_type') ||
                documents[0].hasOwnProperty('ProjectUploadModel')
              )
                ? documents
                : documents.filter(
                    (ele) =>
                      ele.hasOwnProperty('sub_doc_type') ||
                      (ele.hasOwnProperty('ProjectUploadModel') &&
                        ele.ProjectUploadModel.project_sub_doc_type_id ===
                          null),
                  )
              )
                .slice(
                  0,
                  this.state.isShowingMore
                    ? selectedSubDocType ||
                      this.props.isRegulationsSection ||
                      !(
                        documents[0].hasOwnProperty('sub_doc_type') ||
                        documents[0].hasOwnProperty('ProjectUploadModel')
                      )
                      ? documents.length
                      : documents.filter(
                          (ele) =>
                            ele.hasOwnProperty('sub_doc_type') ||
                            (ele.hasOwnProperty('ProjectUploadModel') &&
                              ele.ProjectUploadModel.project_sub_doc_type_id ===
                                null),
                        ).length
                    : this.props.showMoreThreshold,
                )
                .filter((ele) => {
                  if (!ele.ProjectUploadModel) {
                    return true;
                  }

                  return ele.ProjectUploadModel.status !== 'Replaced';
                })
                .map((doc, index) => {
                  let projectId = null;

                  if (
                    doc.ProjectUploadModel &&
                    doc.ProjectUploadModel.project_id
                  ) {
                    projectId = doc.ProjectUploadModel.project_id;
                  } else if (doc.projectId) {
                    projectId = doc.projectId;
                  }

                  if (
                    doc &&
                    doc.ProjectUploadModel &&
                    doc.ProjectUploadModel.project_sub_doc_type_id
                  ) {
                    // remove docs that belong to Sub-Folders from main Project Documents page
                    return <></>;
                  }

                  if (doc.hasOwnProperty('sub_doc_type')) {
                    // shows BLUE BACKGROUND SUB-FOLDER within the main doc_type
                    const hasLeadingColumn =
                      !this.props.isPublic &&
                      isProjectDocumentsPage &&
                      userCanMove &&
                      !docTypesWithCheckboxExcluded.includes(actualGroupName || groupName);

                    return (
                      <tr
                        className='file-row folder-row'
                        onClick={() => setSelectedSubDocType(doc)}
                        key={index}
                      >
                        {hasLeadingColumn && (
                          <td
                            className='file-row__column'
                            style={{ width: '50px' }}
                          >
                            <FontAwesomeIcon icon={faFolder} color='#48af98' />
                          </td>
                        )}
                        <td
                          className='file-row__column file-row__column--fill col-primary'
                          style={{
                            textTransform: 'uppercase',
                            fontWeight: '900',
                          }}
                        >
                          {!hasLeadingColumn && !this.props.isPublic && (
                            <FontAwesomeIcon
                              icon={faFolder}
                              color='#48af98'
                              style={{ marginRight: '0.5rem' }}
                            />
                          )}
                          {doc.sub_doc_type.name}
                        </td>
                        <td className='file-row__column file-row__column--type'></td>
                        {this.props.isPublic ? (
                          <></>
                        ) : (
                          <>
                            <td className='file-row__column file-row__column--hide-on-mobile file-row__column--auto-width'></td>
                            <td className='file-row__column file-row__column--hide-on-mobile file-row__column--auto-width'></td>
                            {(groupName === 'Permits' ||
                              actualGroupName === 'Permits') && (
                              <>
                                <td className='file-row__column file-row__column--hide-on-mobile file-row__column--auto-width'></td>
                              </>
                            )}
                          </>
                        )}
                        <td className='file-row__column file-row__column--auto-width'></td>
                      </tr>
                    );
                  }

                  return (
                    <FileRow
                      key={doc.id}
                      projectId={projectId}
                      index={index}
                      fileName={doc.name}
                      document={doc}
                      canDownload={canDownload}
                      canDrag={canDrag}
                      downloadUrl={
                        canDownload
                          ? uploadApi.getDownloadUrl(
                              doc.upload ? doc.upload.GUID : doc.GUID,
                              null,
                              false,
                              Date.now(),
                              projectId,
                            )
                          : ''
                      }
                      canEdit={
                        canEdit &&
                        (doc.mime_type === 'application/pdf' ||
                          (doc.upload &&
                            doc.upload.mime_type === 'application/pdf')) &&
                        canTenantEdit
                      }
                      canDelete={
                        doc.scope === 'master'
                          ? false
                          : location === 'bmp-docs'
                          ? (doc.project_id || doc.ProjectUploadModel) &&
                            !doc.docTypeName &&
                            canDelete
                          : !doc.docTypeName && canDelete
                      }
                      canReplace={
                        location === 'bmp-docs'
                          ? (doc.project_id || doc.ProjectUploadModel) &&
                            !doc.docTypeName &&
                            canReplace
                          : !doc.docTypeName && canReplace
                      }
                      canRename={
                        location === 'bmp-docs'
                          ? (doc.project_id || doc.ProjectUploadModel) &&
                            !doc.docTypeName &&
                            canRename
                          : !doc.docTypeName && canRename
                      }
                      canTrackPermit={
                        (actualGroupName === 'Permits' || groupName === 'Permits') && !isPublic
                      }
                      handleTrackPermit={() =>
                        handleTrackPermit(doc.ProjectUploadModel)
                      }
                      handleDownload={() => handleDownload(doc)}
                      handleDelete={() => handleDelete(doc)}
                      handleEdit={() => handleEdit(doc)}
                      handleRename={() => handleRename(doc)}
                      handleReplace={(newDoc) => handleReplace(newDoc, doc)}
                      permCheck={permCheck}
                      label={label}
                      maxFileSize={maxFileSize}
                      minimumImageDimensions={minimumImageDimensions}
                      parentRef={this.tableRef}
                      onMove={onMove}
                      onDrop={onDrop}
                      documentGroupName={actualGroupName || groupName}
                      document_date={document_date || isAdmin}
                      isProjectDocumentsPage={isProjectDocumentsPage}
                      selectedDocument={this.state.selectedDocument}
                      setSelectedDocument={(selectedIds) =>
                        this.setState({ selectedDocument: selectedIds })
                      }
                      userCanMove={userCanMove}
                      documentType={this.props.documentType}
                    />
                  );
                })}
            </tbody>
          </table>
        ) : null}

        {(selectedSubDocType || (!isProjectDocumentsPage && documents.length)
          ? documents.length
          : documents.filter(
              (ele) =>
                ele.hasOwnProperty('sub_doc_type') ||
                (ele.hasOwnProperty('ProjectUploadModel') &&
                  ele.ProjectUploadModel.project_sub_doc_type_id === null) || 
                ele.hasOwnProperty('GroupUploadModel')
            ).length) > this.props.showMoreThreshold && (
          <Button
            small={true}
            className='document-group__expand-action'
            onClick={() => {
              this.toggleShowMore();
            }}
          >
            Show {this.state.isShowingMore ? 'Less' : 'More'}
          </Button>
        )}

        <Modal
          title='Warning'
          subTitle='This document is associated with an active permit.'
          show={this.state.showWarningForPermitDoc}
          handleClose={() => {
            this.setState({ showWarningForPermitDoc: false });
          }}
          submitBtnText='Proceed'
          handleSubmit={() => {
            this.setState({ showWarningForPermitDoc: false });
            this.setState({ showMoveDocModal: true });
          }}
          cancelBtn={true}
        >
          <p>
            You're about to relocate a permit file that is currently being
            tracked to another folder. If you continue, tracking will be
            cancelled. Do you wish to proceed?
          </p>
        </Modal>
        <Modal
          title='Select Destination Folder'
          subTitle='Choose the destination folder where you want to move the document.'
          show={this.state.showMoveDocModal}
          submitBtnText='Confirm'
          handleSubmit={() => {
            if (this.state.destinationMainFolderId === null) {
              this.setState({ modalErrorMsg: 'Choose destination folder' });

              return;
            } else if (
              this.state.destinationAsSubFolderCheck &&
              this.state.destinationSubFolderId === null
            ) {
              this.setState({
                modalErrorMsg: 'Choose sub folder OR uncheck the box',
              });

              return;
            } else if (
              !this.state.destinationAsSubFolderCheck &&
              this.state.selectedDocument
                .map(
                  (ele) =>
                    ele.hasOwnProperty('ProjectUploadModel') &&
                    ele.ProjectUploadModel.hasOwnProperty(
                      'project_doc_type_id',
                    ) &&
                    ele.ProjectUploadModel.project_doc_type_id,
                )
                .includes(
                  this.state.selectedMainDestinationFolder.project_doc_type_id,
                ) &&
              this.state.selectedDocument.filter(
                (ele) =>
                  ele.hasOwnProperty('ProjectUploadModel') &&
                  ele.ProjectUploadModel.hasOwnProperty(
                    'project_sub_doc_type_id',
                  ) &&
                  ele.ProjectUploadModel.project_sub_doc_type_id === null,
              ).length
            ) {
              this.setState({
                modalErrorMsg:
                  'Destination and source of one of the file is same',
              });

              return;
            } else if (
              this.state.selectedDocument
                .map(
                  (ele) =>
                    ele.hasOwnProperty('ProjectUploadModel') &&
                    ele.ProjectUploadModel.hasOwnProperty(
                      'project_sub_doc_type_i',
                    ) &&
                    ele.ProjectUploadModel.project_sub_doc_type_i,
                )
                .includes(this.state.selectedSubDestinationFolder.id)
            ) {
              this.setState({
                modalErrorMsg:
                  'Destination and source of one of the file is same',
              });

              return;
            } else {
              this.setState({ isLoadingForModal: true });
              this.setState({ modalErrorMsg: '' });

              uploadApi
                .move(
                  this.state.selectedDocument[0].ProjectUploadModel.project_id,
                  this.state.sourceMainFolderId,
                  this.state.destinationMainFolderId,
                  this.state.destinationSubFolderId,
                  this.state.destinationAsSubFolderCheck,
                  this.state.selectedDocument.map((ele) => ele.id),
                )
                .then(async () => {
                  setShouldReloadDocumentsPage((prevState) => !prevState);
                  this.setState({ selectedDocument: [] });
                  this.setState({ isLoadingForModal: false });
                  this.setState({ showMoveDocModal: false });
                  await reloadSelectedSubDocTypeData();
                })
                .catch((error) => console.log(error));
            }
          }}
          disableSubmit={this.state.isLoadingForModal}
          handleClose={() => {
            this.setState({ modalErrorMsg: '' });
            this.setState({ selectedDocument: [] });
            this.setState({ sourceMainFolderId: null });
            this.setState({ destinationMainFolderId: null });
            this.setState({ destinationSubFolderId: null });
            this.setState({ selectedMainDestinationFolder: null });
            this.setState({ selectedSubDestinationFolder: null });
            this.setState({ showMoveDocModal: false });
          }}
          cancelBtn={true}
          errorMsg={this.state.modalErrorMsg}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <select
              className='document-group__destination-modal-dropdown'
              onChange={(event) => onMainDestinationFolderSelectHandler(event)}
            >
              <option value='' hidden>
                Choose Destination Folder
              </option>
              {this.props.docTypes ? (
                this.props.docTypes
                  .filter(
                    (ele) =>
                      !docTypesExcludedFromDestinationOptions.includes(
                        ele.name,
                      ),
                  )
                  .map((ele, index) => {
                    return (
                      <option value={JSON.stringify(ele)} key={index}>
                        {ele.name.length > 45
                          ? `${ele.name.substring(0, 45)}...`
                          : ele.name}
                      </option>
                    );
                  })
              ) : (
                <></>
              )}
            </select>

            <span style={{ display: 'flex' }}>
              <input
                id='move-to-sub-destination-folder'
                type='checkbox'
                style={{ width: '2%', marginRight: '10px' }}
                checked={this.state.destinationAsSubFolderCheck}
                onClick={() =>
                  this.setState({
                    destinationAsSubFolderCheck:
                      !this.state.destinationAsSubFolderCheck,
                  })
                }
              />
              <label
                className='radio-label'
                htmlFor='move-to-sub-destination-folder'
              >
                Move to Sub Folder
              </label>
            </span>

            <select
              className='document-group__destination-modal-dropdown'
              onChange={(event) => onSubDestinationFolderSelectHandler(event)}
              disabled={!this.state.destinationAsSubFolderCheck}
            >
              <option value='' hidden>
                Choose Sub Folder
              </option>
              {this.state.selectedMainDestinationFolder &&
              this.state.selectedMainDestinationFolder.documents.filter((ele) =>
                ele.hasOwnProperty('sub_doc_type'),
              ).length ? (
                this.state.selectedMainDestinationFolder.documents
                  .filter((ele) => ele.hasOwnProperty('sub_doc_type'))
                  .map((ele) => {
                    return (
                      <option value={JSON.stringify(ele)}>
                        {ele.sub_doc_type.name.length > 45
                          ? `${ele.sub_doc_type.name.substring(0, 45)}...`
                          : ele.sub_doc_type.name}
                      </option>
                    );
                  })
              ) : (
                <option value='' disabled>
                  No Sub Folder Found
                </option>
              )}
            </select>
          </div>
        </Modal>
        <Modal
          title='Organize Documents'
          show={
            this.state.showReorderModal && this.state.tempReorderDocs.length
          }
          handleClose={() => {
            this.setState({ showReorderModal: false });
          }}
          handleSubmit={async (x) => {
            await handleSubmitReorderProjectDocs();
          }}
          submitBtnText='Save'
        >
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId='documentGroup'>
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {this.state.tempReorderDocs.length &&
                    this.state.tempReorderDocs.map((ele, index) => {
                      return (
                        <Draggable
                          key={`${index}`}
                          draggableId={`${index}`}
                          index={index}
                        >
                          {(provide) => (
                            <div
                              ref={provide.innerRef}
                              {...provide.draggableProps}
                              {...provide.dragHandleProps}
                              style={{
                                ...provide.draggableProps.style,
                                left: 'auto !important',
                                top: 'auto !important',
                                marginBottom: '5px',
                              }}
                            >
                              {
                                <span className='document-group-reorder-modal__draggable-file'>
                                  <FontAwesomeIcon
                                    icon='grip-lines'
                                    size='sm'
                                    color='#0d2330'
                                  />
                                  <span className='document-group-reorder-modal__draggable-name'>
                                    {ele.name ||
                                      ele.sub_doc_type?.name ||
                                      ele.upload?.name ||
                                      ''}
                                  </span>
                                </span>
                              }
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Modal>
        <Modal
          title='Add Sub Folder'
          subTitle='Create sub folder within this doc type.'
          show={this.state.showAddNewSubDocTypeModal}
          submitBtnText='Add'
          handleSubmit={() => {
            if (this.state.newSubDocTypeName === '') {
              this.setState({
                modalErrorMsg: "Can't have name as empty string",
              });

              return;
            } else {
              this.setState({ isLoadingForModal: true });
              this.setState({ modalErrorMsg: '' });

              const isRegulation = this.props.isRegulationsSection || groupName === 'Regulations';

              const addPromise = isRegulation
                ? uploadApi.groupSubFolder.add(
                    this.props.regulationDocumentGroupId,
                    this.state.newSubDocTypeName,
                    this.props.projectId || null,
                  )
                : uploadApi.subFolder.add(
                    this.props.projectId,
                    documentType && documentType.project_doc_type_id,
                    this.state.newSubDocTypeName,
                  );

              addPromise
                .then(() => {
                  this.setState({ isLoadingForModal: false });
                  this.setState({ showAddNewSubDocTypeModal: false });
                  if (isRegulation && this.props.reloadDocs) {
                    this.props.reloadDocs();
                  } else {
                    setShouldReloadDocumentsPage((prevState) => !prevState);
                  }
                })
                .catch((error) => console.log(error));
            }
          }}
          disableSubmit={this.state.isLoadingForModal}
          handleClose={() => {
            this.setState({ modalErrorMsg: '' });
            this.setState({ destinationMainFolderId: null });
            this.setState({ showAddNewSubDocTypeModal: false });
          }}
          cancelBtn={true}
          errorMsg={this.state.modalErrorMsg}
        >
          <input
            style={{ display: 'flex', justifyContent: 'center' }}
            onChange={(event) =>
              this.setState({ newSubDocTypeName: event.target.value })
            }
          />
        </Modal>
        <Modal
          title='Rename'
          subTitle='Rename this Sub Folder.'
          show={this.state.showRenameSubDocTypeModal}
          submitBtnText='Submit'
          handleSubmit={() => {
            if (this.state.updatedSubDocTypeName === '') {
              this.setState({
                modalErrorMsg: "Can't have name as empty string",
              });

              return;
            } else {
              this.setState({ isLoadingForModal: true });
              this.setState({ modalErrorMsg: '' });

              const isRegulationFolder = selectedSubDocType && selectedSubDocType.is_regulation_folder;
              const renamePromise = isRegulationFolder
                ? uploadApi.groupSubFolder.rename(
                    selectedSubDocType.document_group_id,
                    selectedSubDocType.id,
                    this.state.updatedSubDocTypeName,
                    selectedSubDocType.is_project_folder
                      ? 'project'
                      : 'master',
                    this.props.projectId,
                  )
                : uploadApi.subFolder.rename(
                    documentType.project_doc_type_id,
                    selectedSubDocType,
                    this.state.updatedSubDocTypeName,
                  );

              renamePromise
                .then(async () => {
                  this.setState({ isLoadingForModal: false });
                  this.setState({ showRenameSubDocTypeModal: false });
                  if (isRegulationFolder && this.props.reloadDocs) {
                    this.props.reloadDocs();
                  } else {
                    setShouldReloadDocumentsPage((prevState) => !prevState);
                  }
                  await reloadSelectedSubDocTypeData();
                })
                .catch((error) => console.log(error));
            }
          }}
          disableSubmit={this.state.isLoadingForModal}
          handleClose={() => {
            this.setState({ modalErrorMsg: '' });
            this.setState({ showRenameSubDocTypeModal: false });
            this.setState({ updatedSubDocTypeName: null });
          }}
          cancelBtn={true}
          errorMsg={this.state.modalErrorMsg}
        >
          <input
            style={{ display: 'flex', justifyContent: 'center' }}
            value={
              this.state.updatedSubDocTypeName === null
                ? this.props.selectedSubDocType &&
                  this.props.selectedSubDocType.sub_doc_type.name
                : this.state.updatedSubDocTypeName
            }
            onChange={(event) =>
              this.setState({ updatedSubDocTypeName: event.target.value })
            }
          />
        </Modal>
        <Modal
          title='Are you sure you want to delete this Sub Folder?'
          subTitle='Warning! This action cannot be undone.'
          show={this.state.showDeleteSubDocTypeModal}
          submitBtnText='Delete'
          handleSubmit={() => {
            this.setState({ isLoadingForModal: true });
            this.setState({ modalErrorMsg: '' });

            const isRegulationFolder = selectedSubDocType && selectedSubDocType.is_regulation_folder;
            const deletePromise = isRegulationFolder
              ? uploadApi.groupSubFolder.delete(
                  selectedSubDocType.document_group_id,
                  selectedSubDocType.id,
                  selectedSubDocType.is_project_folder ? 'project' : 'master',
                  this.props.projectId,
                )
              : uploadApi.subFolder.delete(documentType.project_doc_type_id, selectedSubDocType);

            deletePromise
              .then(() => {
                this.setState({ isLoadingForModal: false });
                this.setState({ showDeleteSubDocTypeModal: false });
                if (isRegulationFolder && this.props.reloadDocs) {
                  this.props.reloadDocs();
                } else {
                  setShouldReloadDocumentsPage((prevState) => !prevState);
                }
                setSelectedSubDocType('');
              })
              .catch((error) => console.log(error));
          }}
          disableSubmit={this.state.isLoadingForModal}
          handleClose={() => {
            this.setState({ modalErrorMsg: '' });
            this.setState({ showDeleteSubDocTypeModal: false });
          }}
          cancelBtn={true}
          errorMsg={this.state.modalErrorMsg}
        >
          <p>
            This action will delete this Sub Folder, along with all the
            documents within this Sub Folder.
            {actualGroupName &&
              actualGroupName === 'Permits' &&
              ' This will also delete any active permits associated with these files.'}
          </p>
        </Modal>
      </section>
    );
  }
}

const FileCardList = ({ permCheck, ...props }) => {
  const roleStore = useContext(RolesContext);
  const appContext = useContext(AppContext);
  const isAdmin =
    appContext.get('user').roleName === 'Admin' ||
    appContext.get('user').roleName === 'Super Admin';
  const canTenantEdit = useContext(TenantStore);
  const projectContext = useContext(ProjectContext);
  const inspectionContext = useContext(InspectionContext);
  const history = useHistory();
  const isPublic = history.location.pathname.startsWith('/public');

  if (!permCheck) {
    permCheck = roleStore.userHasPermission;
  }

  return (
    <FileCardListUI
      {...props}
      permCheck={permCheck}
      isAdmin={isAdmin}
      canTenantEdit={canTenantEdit.tenantHasFeature('PDF Editing')}
      projectContext={projectContext}
      inspectionContext={inspectionContext}
      isPublic={isPublic}
    />
  );
};

export default FileCardList;
